<template>
  <div class="mt-4 alert alert-info">
    <h3>404 - Page Not Found</h3>
    <p>Sorry, you tried to access a page that does not exist.</p>
  </div>
</template>

<script>
export default {}
</script>
